import { html, property, TemplateResult } from 'lit-element';
import { KatLitElement, register } from '../../../shared/base';

/**
 * @component {kat-data-grid} KatDataGrid A data table that supports hooks for sorting, filtering, and pagination.
 * @guideline Do This is something you should do.
 * @guideline Dont This is something you should not do.
 * @event change An example of how to document an event.
 * @status Production
 * @theme flo
 * @example Default {"label": "hello"}
 */

export interface ActionBarHandler {
  renderBarContent(container: KatDataGridActionBar): TemplateResult;

  firstUpdated(container: HTMLElement): void;
}

@register('kat-data-grid-action-bar')
export class KatDataGridActionBar extends KatLitElement {
  @property() handler?: ActionBarHandler;

  // disable shadow-dom
  createRenderRoot() {
    return this;
  }

  firstUpdated(): void {
    const container = this.querySelector<HTMLElement>('.action-bar-container');

    if (container && this.handler) {
      this.handler.firstUpdated(container);
    }
  }

  render() {
    return html`
      <div class="action-bar-wrapper">
        <div class="action-bar-container">
          ${this.handler?.renderBarContent(this)}
        </div>
      </div>
    `;
  }
}
